/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 1821
// module chunks = 0